// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Enemy = require("../Chip.Model.Enemy/index.js");
var Chip_Model_Inventory = require("../Chip.Model.Inventory/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Model_WallType = require("../Chip.Model.WallType/index.js");
var Chip_Mutation_Level = require("../Chip.Mutation.Level/index.js");
var Chip_Utils = require("../Chip.Utils/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var buildConnections = (function () {
    var $23 = Data_Map_Internal.fromFoldable(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Ord.ordInt)))(Data_Foldable.foldableArray);
    var $24 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return new Data_Tuple.Tuple(v.trap, v.button);
    });
    return function ($25) {
        return $23($24($25));
    };
})();
var build = function (v) {
    var initLevel = {
        player: {
            pos: {
                x: 0,
                y: 0
            },
            direction: Chip_Model_Direction.Down.value,
            turnedAt: 0,
            movedAt: 0
        },
        tiles: Data_Map_Internal.empty,
        inventory: Chip_Model_Inventory.initInventory,
        chipsLeft: v.chips,
        enemies: Data_Map_Internal.empty,
        trapConnections: Data_Maybe.maybe(Data_Map_Internal.empty)(buildConnections)(v.trapConnections),
        blocks: Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(v.blocks),
        hint: v.hint,
        ticksLeft: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Semiring.mul(Data_Semiring.semiringInt)(10))(v.timeLimit),
        tick: 0
    };
    var addCell = function (p) {
        return function (c) {
            var insertTile = function (tile) {
                return function (l) {
                    return {
                        player: l.player,
                        tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                            return "y";
                        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                            return "x";
                        }))(Data_Ord.ordInt)))(p)(tile)(l.tiles),
                        inventory: l.inventory,
                        chipsLeft: l.chipsLeft,
                        hint: l.hint,
                        enemies: l.enemies,
                        blocks: l.blocks,
                        trapConnections: l.trapConnections,
                        ticksLeft: l.ticksLeft,
                        tick: l.tick
                    };
                };
            };
            if (c === " ") {
                return Control_Category.identity(Control_Category.categoryFn);
            };
            if (c === "#") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Solid.value));
            };
            if (c === "X") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Invisible.value));
            };
            if (c === "H") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Hidden.value));
            };
            if (c === "%") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Blue.value));
            };
            if (c === "'") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Fake.value));
            };
            if (c === "O") {
                return insertTile(new Chip_Model_Tile.Wall(Chip_Model_WallType.Recessed.value));
            };
            if (c === "_") {
                return insertTile(new Chip_Model_Tile.Wall(new Chip_Model_WallType.Flat(Chip_Model_Direction.Down.value)));
            };
            if (c === "|") {
                return insertTile(new Chip_Model_Tile.Wall(new Chip_Model_WallType.Flat(Chip_Model_Direction.Right.value)));
            };
            if (c === "+") {
                return insertTile(Chip_Model_Tile.Chip.value);
            };
            if (c === "r") {
                return insertTile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Red.value)));
            };
            if (c === "c") {
                return insertTile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Cyan.value)));
            };
            if (c === "y") {
                return insertTile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Yellow.value)));
            };
            if (c === "g") {
                return insertTile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Green.value)));
            };
            if (c === "R") {
                return insertTile(new Chip_Model_Tile.Door(Chip_Model_Color.Red.value));
            };
            if (c === "C") {
                return insertTile(new Chip_Model_Tile.Door(Chip_Model_Color.Cyan.value));
            };
            if (c === "Y") {
                return insertTile(new Chip_Model_Tile.Door(Chip_Model_Color.Yellow.value));
            };
            if (c === "G") {
                return insertTile(new Chip_Model_Tile.Door(Chip_Model_Color.Green.value));
            };
            if (c === "b") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Bee(Chip_Model_Direction.Up.value));
            };
            if (c === "B") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Bee(Chip_Model_Direction.Right.value));
            };
            if (c === "~") {
                return insertTile(Chip_Model_Tile.Water.value);
            };
            if (c === "^") {
                return insertTile(Chip_Model_Tile.Fire.value);
            };
            if (c === "t") {
                return insertTile(Chip_Model_Tile.Thief.value);
            };
            if (c === "\u22a4") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Tank(Chip_Model_Direction.Down.value));
            };
            if (c === "\u22a3") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Tank(Chip_Model_Direction.Left.value));
            };
            if (c === "\u22a5") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Tank(Chip_Model_Direction.Up.value));
            };
            if (c === "\u22a2") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Tank(Chip_Model_Direction.Right.value));
            };
            if (c === "\u2193") {
                return insertTile(new Chip_Model_Tile.Force(Chip_Model_Direction.Down.value));
            };
            if (c === "\u2190") {
                return insertTile(new Chip_Model_Tile.Force(Chip_Model_Direction.Left.value));
            };
            if (c === "\u2191") {
                return insertTile(new Chip_Model_Tile.Force(Chip_Model_Direction.Up.value));
            };
            if (c === "\u2192") {
                return insertTile(new Chip_Model_Tile.Force(Chip_Model_Direction.Right.value));
            };
            if (c === "*") {
                return insertTile(Chip_Model_Tile.Bomb.value);
            };
            if (c === "@") {
                return function (v1) {
                    return {
                        player: {
                            pos: p,
                            direction: v1.player.direction,
                            turnedAt: v1.player.turnedAt,
                            movedAt: v1.player.movedAt
                        },
                        tiles: v1.tiles,
                        inventory: v1.inventory,
                        chipsLeft: v1.chipsLeft,
                        hint: v1.hint,
                        enemies: v1.enemies,
                        blocks: v1.blocks,
                        trapConnections: v1.trapConnections,
                        ticksLeft: v1.ticksLeft,
                        tick: v1.tick
                    };
                };
            };
            if (c === "-") {
                return insertTile(Chip_Model_Tile.Socket.value);
            };
            if (c === "<") {
                return insertTile(Chip_Model_Tile.Exit.value);
            };
            if (c === "?") {
                return insertTile(Chip_Model_Tile.Hint.value);
            };
            if (c === "o") {
                return insertTile(Chip_Model_Tile.Teleport.value);
            };
            if (c === "\u2016") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Ball(Chip_Model_Direction.Up.value));
            };
            if (c === "=") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Ball(Chip_Model_Direction.Left.value));
            };
            if (c === "\u219e") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Left.value));
            };
            if (c === "\u219f") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Up.value));
            };
            if (c === "\u21a0") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Right.value));
            };
            if (c === "\u21a1") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Down.value));
            };
            if (c === "\u21e0") {
                return insertTile(new Chip_Model_Tile.CloneMachine(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Left.value)));
            };
            if (c === "\u21e1") {
                return insertTile(new Chip_Model_Tile.CloneMachine(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Up.value)));
            };
            if (c === "\u21e2") {
                return insertTile(new Chip_Model_Tile.CloneMachine(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Right.value)));
            };
            if (c === "\u21e3") {
                return insertTile(new Chip_Model_Tile.CloneMachine(new Chip_Model_Enemy.FireBall(Chip_Model_Direction.Down.value)));
            };
            if (c === "\u261d") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Glider(Chip_Model_Direction.Up.value));
            };
            if (c === "\u261e") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Glider(Chip_Model_Direction.Right.value));
            };
            if (c === "\u261f") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Glider(Chip_Model_Direction.Down.value));
            };
            if (c === "\u261c") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Glider(Chip_Model_Direction.Left.value));
            };
            if (c === "S") {
                return insertTile(new Chip_Model_Tile.Item(Chip_Model_Item.SkiSkates.value));
            };
            if (c === "U") {
                return insertTile(new Chip_Model_Tile.Item(Chip_Model_Item.SuctionBoots.value));
            };
            if (c === "I") {
                return insertTile(new Chip_Model_Tile.Item(Chip_Model_Item.FireBoots.value));
            };
            if (c === "F") {
                return insertTile(new Chip_Model_Tile.Item(Chip_Model_Item.Flippers.value));
            };
            if (c === "\u255d") {
                return insertTile(new Chip_Model_Tile.IceCorner(Chip_Model_Direction.Down.value));
            };
            if (c === "\u255a") {
                return insertTile(new Chip_Model_Tile.IceCorner(Chip_Model_Direction.Left.value));
            };
            if (c === "\u2554") {
                return insertTile(new Chip_Model_Tile.IceCorner(Chip_Model_Direction.Up.value));
            };
            if (c === "\u2557") {
                return insertTile(new Chip_Model_Tile.IceCorner(Chip_Model_Direction.Right.value));
            };
            if (c === "\u256c") {
                return insertTile(Chip_Model_Tile.Ice.value);
            };
            if (c === "[") {
                return insertTile(new Chip_Model_Tile.SwitchableWall(Chip_Model_SwitchState.On.value));
            };
            if (c === "]") {
                return insertTile(new Chip_Model_Tile.SwitchableWall(Chip_Model_SwitchState.Off.value));
            };
            if (c === ".") {
                return insertTile(Chip_Model_Tile.WallButton.value);
            };
            if (c === ",") {
                return insertTile(Chip_Model_Tile.TankButton.value);
            };
            if (c === ":") {
                return insertTile(Chip_Model_Tile.TrapButton.value);
            };
            if (c === "\u21ba") {
                return insertTile(Chip_Model_Tile.CloneMachineButton.value);
            };
            if (c === ";") {
                return insertTile(Chip_Model_Tile.Trap.value);
            };
            if (c === "\u21c8") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Teeth(Chip_Model_Direction.Up.value));
            };
            if (c === "\u21c9") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Teeth(Chip_Model_Direction.Right.value));
            };
            if (c === "\u21ca") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Teeth(Chip_Model_Direction.Down.value));
            };
            if (c === "\u21c7") {
                return Chip_Mutation_Level.addEnemy(p)(new Chip_Model_Enemy.Teeth(Chip_Model_Direction.Left.value));
            };
            if (c === "\u2248") {
                return insertTile(Chip_Model_Tile.Dirt.value);
            };
            if (c === "\u2591") {
                return insertTile(Chip_Model_Tile.Gravel.value);
            };
            if (c === "0") {
                return Chip_Mutation_Level.addBlock(p);
            };
            return Control_Category.identity(Control_Category.categoryFn);
        };
    };
    return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (level) {
        return function (v1) {
            return Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v2) {
                return addCell({
                    x: v2.i,
                    y: v1.i
                })(v2.v);
            })(level)(v1.v);
        };
    })(initLevel)(Chip_Utils.addIndex(Data_Functor.map(Data_Functor.functorArray)(function ($26) {
        return Chip_Utils.addIndex(Data_String_CodeUnits.toCharArray($26));
    })(v.grid)));
};
module.exports = {
    build: build
};
